import { jsPDF } from "jspdf";
import { money, RENTAL_LABEL, STATUS, COMPANY } from "@/lib/api";

export function buildCommunityPdf(c, url) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  let y = 0;
  doc.setFillColor(11, 33, 80);
  doc.rect(0, 0, W, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(c.name, 40, 45);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(`${c.city}, ${c.state}  •  ${STATUS[c.status]?.label || ""}  •  Explore HOA's`, 40, 68);
  y = 120;
  doc.setTextColor(15, 23, 42);

  const section = (title, rows) => {
    if (y > 700) { doc.addPage(); y = 50; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(3, 122, 109);
    doc.text(title, 40, y); y += 8;
    doc.setDrawColor(226, 232, 240); doc.line(40, y, W - 40, y); y += 16;
    doc.setFontSize(10.5); doc.setTextColor(15, 23, 42);
    rows.filter(([, v]) => v != null && v !== "").forEach(([k, v]) => {
      doc.setFont("helvetica", "bold"); doc.text(`${k}:`, 40, y);
      doc.setFont("helvetica", "normal");
      const lines = doc.splitTextToSize(String(v), W - 210);
      doc.text(lines, 170, y); y += 15 * lines.length + 2;
      if (y > 740) { doc.addPage(); y = 50; }
    });
    y += 10;
  };

  section("Fees", [[c.fee_estimated ? "Est. monthly fee" : "Monthly fee", c.fee_estimated ? money(c.monthly_fee) : c.fee_range || money(c.monthly_fee)],
    [c.fee_estimated ? "Est. yearly fee" : "Yearly fee", c.fee_frequency === "Monthly" && c.monthly_fee != null ? `${money(c.monthly_fee * 12)}/yr` : null],
    ["Note", c.fee_estimated ? "Estimate only. Not confirmed by the HOA." : null], ["Frequency", c.fee_frequency],
    ["Transfer fee", c.transfer_fee != null ? money(c.transfer_fee) : null], ["Fee includes", (c.fee_includes || []).join(", ")],
    ...(c.fee_notes || []).map((n, i) => [`Reported ${i + 1}`, n])]);
  section("Rules & Restrictions", [["Pets", c.pet_policy], ["Rentals", c.rental_notes || RENTAL_LABEL[c.rental_policy]],
    ["Parking", c.parking_rules], ["Architectural", c.architectural_rules]]);
  section("Community", [["Type", c.community_type], ["Amenities", (c.amenities || []).join(", ")], ["Address", c.address],
    ["Phone", c.phone], ["Website", c.website]]);
  if (c.fee_history?.length) section("Fee History", c.fee_history.map((h) => [String(h.year), `${money(h.monthly_fee)}/mo`]));
  section("Source", [["Data status", STATUS[c.status]?.hint], ["Page", url]]);

  doc.setFontSize(8.5); doc.setTextColor(100, 116, 139);
  doc.text(doc.splitTextToSize(`Information is provided for reference only and may be incomplete or outdated. Always confirm fees and rules with the association. © ${new Date().getFullYear()} ${COMPANY}.`, W - 80), 40, 770);
  doc.save(`${c.slug}.pdf`);
}
